export const OfferStatus = {
  None: 0,
  Active: 1,
  Cancelled: 2,
  AcceptedBySeller: 3,
  AcceptedByBuyer: 4,
}
